import './Styles/App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './Pages/Home/Home';
import Header from './Components/Header';
import { useEffect, useState } from 'react';
import Left, { NavButton } from './Components/Sidebars/Left';
import Right from './Components/Sidebars/Right';
import Search from './Components/Search';
import Fade from 'react-reveal/Fade'
import TagsCollection from './Components/PopularTags';
import Poll from './Pages/Poll/Poll';
import Create from './Pages/Create/Create';
import SignUp from './Pages/Auth/SignUp';
import Login from './Pages/Auth/Login';
import Account from './Pages/Auth/Account';
import SearchResults from './Pages/Search/Search.jsx'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firestore } from './firebase';
import { slide as Menu } from 'react-burger-menu'
import PRO from './Pages/Checkout/PRO';
import Checkout from './Pages/Checkout/Checkout';
import Order from './Pages/Checkout/Order';
import { UserContext } from './Helpers/user.context';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import Spinner from './Components/Spinner';

function App() {
    const [authResolved, setAuthResolved] = useState({ done: false })
    const [userData, setUserData] = useState(null)
    useEffect(() => {
        if (window.location.pathname === "/") {
            return window.location.replace("/home")
        }
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                setAuthResolved({ done: true, user: true, uid: user.uid })
                const docRef = doc(firestore, "users", user.uid)
                await getDoc(docRef).then((snap) => {
                    setUserData(snap.data())
                })
            } else {
                setAuthResolved({ done: true, user: false })
            }
        })
    }, [])
    useEffect(() => {
        if (authResolved.done && (!authResolved.user ? true : userData)) {
            const main = document.getElementById("mainSegment")
            setTimeout(() => {
                try {
                    main.classList.add("mainSegmentLoaded")
                } catch {
                    void 0
                }
            }, 300)
            if (auth.currentUser) {
                toast(`Welcome back ${auth.currentUser.displayName}`, {
                    icon: "👋"
                })
            }
        }
    }, [authResolved])
    const AccountSetup = () => {
        useEffect(() => {
            if (authResolved.done) {
                const unsubscribe = onSnapshot(doc(firestore, "users", authResolved.uid), (userDoc) => {
                    if (userDoc.exists()) {
                        setUserData(userDoc.data())
                        unsubscribe()
                    }
                })
            }
        }, [])
        return (
            <div className='flex aic jcc fdc' style={{ width: "100%", height: "100vh" }}>
                <Spinner style={{ minHeight: 100 }} />
                <p style={{ fontWeight: "bold", opacity: .6, marginTop: 0 }}>Logging In...</p>
            </div>
        )
    }
    if (authResolved.done && (!authResolved.user ? true : !!userData)) {
        return (
            <Router>
                <ToastContainer position="bottom-center" style={{ fontWeight: 600, zIndex: 58432957234896723495673429763 }} hideProgressBar={true} />
                <div className='view-height view-width flex fdc'>
                    <UserContext.Provider value={userData}>
                        <Header />
                        <main className='view-width bb flex jcsb f1 topLevelDynamicContentContainer bb' style={{ padding: "0 50px", maxWidth: 1500, margin: "0 auto", marginTop: 100 }}>
                            <div style={{ zIndex: 100000 }} className='f2 segment bb mainSegment' id='mainSegment'>
                                <Routes>
                                    <Route path='/signup' element={<SignUp />} />
                                    <Route path='/login' element={<Login />} />
                                    <Route path='/home' element={<Home />} />
                                    <Route path='/poll/:pollID' element={<Poll />} />
                                    <Route path='/pvt/poll/:pollID' element={<Poll privatePoll />} />
                                    <Route path='/create' element={<Create />} />
                                    <Route path='/account/:uid' element={<Account />} />
                                    <Route path='/search/:term' element={<SearchResults />} />
                                    <Route path="/pro" element={<PRO />} />
                                    <Route path='/pro/checkout' element={<Checkout />} />
                                    <Route path='/pro/checkout/order' element={<Order />} />
                                </Routes>
                            </div>
                            <div style={{ zIndex: 100 }} className="f1 segment rightSegment">
                                <Right tags={[
                                    "Comparison",
                                    "Design",
                                    "Beauty",
                                    "Gaming"
                                ]} />
                            </div>
                        </main>
                    </UserContext.Provider>
                </div>
            </Router>
        );
    } else {
        return <AccountSetup />
    }
}

export default App;
